function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { ConfigContext } from '@/components';
import { useApplicationsList, useCurrentApplication } from '@/components/ApplicationContext';
import { constants } from '@/constants';
import { Box, CircularProgress, Container, Link, Paper, Typography, useTheme } from '@mui/material';
import axios from 'axios';
import Cookies from 'js-cookie';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import FrameImage from '../../../public/FrameImage.jpg';
import './HelpCenterGuideViewer.css';
import authenticatedRoute from '@/views/AuthenticatedRoute';
import { useThemeDetails } from '@/components/ThemeDetailsContext';
import { convertVideoLinksToPlayers, highlightSearchInElement } from '@/utils/helpCenterGuideViewerUtils';
var parseHtmlIntoSections = function parseHtmlIntoSections(htmlContent) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(htmlContent, 'text/html');
    var container = doc.body;
    var h1Elements = Array.from(container.querySelectorAll('h1'));
    if (h1Elements.length === 0) {
        return [{
                title: '',
                content: container.innerHTML,
                id: 'section-0'
            }];
    }
    var getSectionContent = function getSectionContent(parentContainer, currentH1, nextH1) {
        var allElements = Array.from(parentContainer.children);
        var startIndex = allElements.indexOf(currentH1);
        var endIndex = nextH1 ? allElements.indexOf(nextH1) : allElements.length;
        if (startIndex === -1) {
            return currentH1.outerHTML;
        }
        var sectionElements = allElements.slice(startIndex, endIndex);
        return sectionElements.map(function (el) {
            return el.outerHTML;
        }).join('');
    };
    return h1Elements.map(function (h1, index) {
        var _h1$textContent;
        var title = ((_h1$textContent = h1.textContent) === null || _h1$textContent === void 0 ? void 0 : _h1$textContent.trim()) || '';
        var nextH1 = h1Elements[index + 1];
        var content = getSectionContent(container, h1, nextH1);
        return {
            title: title,
            content: content,
            id: "section-".concat(index + 1)
        };
    });
};
var HelpCenterGuideViewer = function HelpCenterGuideViewer() {
    var _useThemeDetails = useThemeDetails(), stateImages = _useThemeDetails.stateImages;
    var _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), sections = _useState2[0], setSections = _useState2[1];
    var _useState3 = useState(''), _useState4 = _slicedToArray(_useState3, 2), searchTerm = _useState4[0], setSearchTerm = _useState4[1];
    var sectionRefs = useRef({});
    var sectionContentRefs = useRef({});
    var _useState5 = useState([]), _useState6 = _slicedToArray(_useState5, 2), applicationsList = _useState6[0], setApplicationsList = _useState6[1];
    var theme = useTheme();
    var _useContext = useContext(ConfigContext), configState = _useContext.configState;
    var _useState7 = useState(true), _useState8 = _slicedToArray(_useState7, 2), isLoadingApplications = _useState8[0], setIsLoadingApplications = _useState8[1];
    var _useState9 = useState(null), _useState0 = _slicedToArray(_useState9, 2), fallbackApplication = _useState0[0], setFallbackApplication = _useState0[1];
    var _useState1 = useState(false), _useState10 = _slicedToArray(_useState1, 2), isInitialized = _useState10[0], setIsInitialized = _useState10[1];
    var _useState11 = useState(''), _useState12 = _slicedToArray(_useState11, 2), bg = _useState12[0], setBg = _useState12[1];
    var productId = Cookies.get('Product Selected');
    var user = Cookies.get('user');
    var selectedLanguage = useMemo(function () {
        try {
            var _JSON$parse;
            return user ? ((_JSON$parse = JSON.parse(user)) === null || _JSON$parse === void 0 || (_JSON$parse = _JSON$parse.details) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.selected_language) || 'en' : 'en';
        }
        catch (_unused) {
            return 'en';
        }
    }, [user]);
    var getApplications = useApplicationsList();
    var currentApp = useCurrentApplication(productId ? Number(productId) : 0);
    var currentApplication = useMemo(function () {
        var sessionApplication = sessionStorage.getItem('current_application');
        if (sessionApplication) {
            try {
                return JSON.parse(sessionApplication);
            }
            catch (_unused2) {
                return currentApp;
            }
        }
        return currentApp;
    }, [currentApp]);
    var resolvedApplication = useMemo(function () {
        return currentApplication !== null && currentApplication !== void 0 ? currentApplication : fallbackApplication;
    }, [currentApplication, fallbackApplication]);
    var selectedHelpCenterUrl = useMemo(function () {
        var _resolvedApplication$;
        return (resolvedApplication === null || resolvedApplication === void 0 || (_resolvedApplication$ = resolvedApplication.details) === null || _resolvedApplication$ === void 0 || (_resolvedApplication$ = _resolvedApplication$.help_center) === null || _resolvedApplication$ === void 0 ? void 0 : _resolvedApplication$[selectedLanguage]) || '';
    }, [resolvedApplication, selectedLanguage]);
    var englishHelpCenterUrl = useMemo(function () {
        var _resolvedApplication$2;
        return (resolvedApplication === null || resolvedApplication === void 0 || (_resolvedApplication$2 = resolvedApplication.details) === null || _resolvedApplication$2 === void 0 || (_resolvedApplication$2 = _resolvedApplication$2.help_center) === null || _resolvedApplication$2 === void 0 ? void 0 : _resolvedApplication$2.en) || '';
    }, [resolvedApplication]);
    useEffect(function () {
        var blobUrl = null;
        var loadBackgroundImage = /*#__PURE__*/ function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
                var response, _t;
                return _regenerator().w(function (_context) {
                    while (1)
                        switch (_context.p = _context.n) {
                            case 0:
                                _context.p = 0;
                                _context.n = 1;
                                return axios.get(FrameImage, {
                                    responseType: 'blob'
                                });
                            case 1:
                                response = _context.v;
                                blobUrl = URL.createObjectURL(response.data);
                                setBg("url(".concat(blobUrl, ")"));
                                _context.n = 3;
                                break;
                            case 2:
                                _context.p = 2;
                                _t = _context.v;
                                setBg('');
                            case 3:
                                return _context.a(2);
                        }
                }, _callee, null, [[0, 2]]);
            }));
            return function loadBackgroundImage() {
                return _ref.apply(this, arguments);
            };
        }();
        void loadBackgroundImage();
        return function () {
            if (blobUrl) {
                URL.revokeObjectURL(blobUrl);
            }
        };
    }, []);
    useEffect(function () {
        var loadApplications = /*#__PURE__*/ function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
                var apps;
                return _regenerator().w(function (_context2) {
                    while (1)
                        switch (_context2.p = _context2.n) {
                            case 0:
                                _context2.p = 0;
                                _context2.n = 1;
                                return getApplications();
                            case 1:
                                apps = _context2.v;
                                setApplicationsList(apps);
                            case 2:
                                _context2.p = 2;
                                setIsLoadingApplications(false);
                                return _context2.f(2);
                            case 3:
                                return _context2.a(2);
                        }
                }, _callee2, null, [[0, , 2, 3]]);
            }));
            return function loadApplications() {
                return _ref2.apply(this, arguments);
            };
        }();
        void loadApplications();
    }, [getApplications]);
    useEffect(function () {
        if (isLoadingApplications) {
            return;
        }
        if (applicationsList.length > 0 && productId && currentApplication) {
            setIsInitialized(true);
            return;
        }
        if (applicationsList.length > 0) {
            var appByName = applicationsList.find(function (app) {
                var _app$details;
                return (app === null || app === void 0 || (_app$details = app.details) === null || _app$details === void 0 || (_app$details = _app$details.baseApp) === null || _app$details === void 0 ? void 0 : _app$details.toLowerCase()) === 'true';
            });
            if (appByName) {
                setFallbackApplication(appByName);
            }
            setIsInitialized(true);
            return;
        }
        setIsInitialized(true);
    }, [applicationsList, currentApplication, isLoadingApplications, productId]);
    useEffect(function () {
        if (!isInitialized) {
            return;
        }
        var loadContentWithFallback = /*#__PURE__*/ function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
                var urlToFetch, response, rawContent, _t2, _t3, _t4;
                return _regenerator().w(function (_context3) {
                    while (1)
                        switch (_context3.p = _context3.n) {
                            case 0:
                                _context3.p = 0;
                                urlToFetch = selectedHelpCenterUrl || englishHelpCenterUrl;
                                if (urlToFetch) {
                                    _context3.n = 1;
                                    break;
                                }
                                throw new Error(constants.help_center_content_not_available);
                            case 1:
                                _context3.p = 1;
                                _context3.n = 2;
                                return axios.get(urlToFetch, {
                                    responseType: 'text'
                                });
                            case 2:
                                response = _context3.v;
                                _context3.n = 9;
                                break;
                            case 3:
                                _context3.p = 3;
                                _t2 = _context3.v;
                                if (!(selectedLanguage !== 'en' && englishHelpCenterUrl)) {
                                    _context3.n = 8;
                                    break;
                                }
                                _context3.p = 4;
                                _context3.n = 5;
                                return axios.get(englishHelpCenterUrl, {
                                    responseType: 'text'
                                });
                            case 5:
                                response = _context3.v;
                                _context3.n = 7;
                                break;
                            case 6:
                                _context3.p = 6;
                                _t3 = _context3.v;
                                throw new Error(constants.help_center_content_not_available);
                            case 7:
                                _context3.n = 9;
                                break;
                            case 8:
                                throw new Error(constants.help_center_content_not_available);
                            case 9:
                                rawContent = convertVideoLinksToPlayers(String(response.data));
                                setSections(parseHtmlIntoSections(rawContent));
                                _context3.n = 11;
                                break;
                            case 10:
                                _context3.p = 10;
                                _t4 = _context3.v;
                                setSections([{
                                        title: constants.help_center_error_title,
                                        content: "<h1>".concat(_t4.message, "</h1>"),
                                        id: 'error-section'
                                    }]);
                            case 11:
                                return _context3.a(2);
                        }
                }, _callee3, null, [[4, 6], [1, 3], [0, 10]]);
            }));
            return function loadContentWithFallback() {
                return _ref3.apply(this, arguments);
            };
        }();
        void loadContentWithFallback();
    }, [englishHelpCenterUrl, isInitialized, selectedHelpCenterUrl, selectedLanguage]);
    useEffect(function () {
        var _iterator = _createForOfIteratorHelper(sections), _step;
        try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var section = _step.value;
                var element = sectionContentRefs.current[section.id];
                if (element) {
                    highlightSearchInElement(element, searchTerm);
                }
            }
        }
        catch (err) {
            _iterator.e(err);
        }
        finally {
            _iterator.f();
        }
    }, [sections, searchTerm]);
    var scrollToSection = function scrollToSection(sectionId) {
        var element = sectionRefs.current[sectionId];
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };
    var setSectionRef = function setSectionRef(sectionId) {
        return function (el) {
            sectionRefs.current[sectionId] = el;
        };
    };
    var setSectionContentRef = function setSectionContentRef(sectionId) {
        return function (el) {
            sectionContentRefs.current[sectionId] = el;
        };
    };
    var hasValidSections = sections.some(function (section) {
        return Boolean(section.title.trim()) && section.id !== 'error-section';
    });
    var renderIndexContent = function renderIndexContent() {
        return /*#__PURE__*/ React.createElement(Box, {
            className: "help-center-index-container"
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h4",
            component: "h1",
            gutterBottom: true,
            sx: {
                color: theme.palette.text.primary,
                mb: 2,
                alignSelf: 'flex-start'
            }
        }, constants.help_center_index), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                width: '100%',
                pl: 0
            }
        }, sections.map(function (section) {
            var _configState$settings, _configState$settings2;
            return /*#__PURE__*/ React.createElement(Box, {
                key: section.id,
                sx: {
                    mb: 2
                }
            }, /*#__PURE__*/ React.createElement(Link, {
                component: "button",
                onClick: function onClick() {
                    return scrollToSection(section.id);
                },
                className: "help-center-index-link",
                sx: _objectSpread({
                    color: (configState === null || configState === void 0 || (_configState$settings = configState.settings) === null || _configState$settings === void 0 ? void 0 : _configState$settings.button_color) === '#FFFFFF' ? '#000000' : configState === null || configState === void 0 || (_configState$settings2 = configState.settings) === null || _configState$settings2 === void 0 ? void 0 : _configState$settings2.button_color
                }, theme.typography.h6)
            }, section.title));
        })));
    };
    var renderHeaderWithImage = function renderHeaderWithImage() {
        var _configState$settings3, _configState$settings4;
        return /*#__PURE__*/ React.createElement(Box, {
            className: "help-center-header-container",
            sx: {
                '&::before': {
                    backgroundImage: bg
                }
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            className: "help-center-header-overlay",
            sx: {
                background: (configState === null || configState === void 0 || (_configState$settings3 = configState.settings) === null || _configState$settings3 === void 0 ? void 0 : _configState$settings3.button_color) || theme.palette.primary.main
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            className: "help-center-header-title-container"
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h2",
            component: "h2",
            className: "help-center-header-title",
            sx: {
                color: (configState === null || configState === void 0 || (_configState$settings4 = configState.settings) === null || _configState$settings4 === void 0 ? void 0 : _configState$settings4.button_color) === '#FFFFFF' ? '#000000' : '#FFFFFF'
            }
        }, constants.help_center_title))));
    };
    if (isLoadingApplications) {
        return /*#__PURE__*/ React.createElement(Box, {
            className: "help-center-loading-container"
        }, stateImages !== null && stateImages !== void 0 && stateImages.Loading ? /*#__PURE__*/ React.createElement(Box, {
            component: "img",
            src: stateImages.Loading,
            alt: "Loading",
            sx: {
                width: 128,
                height: 128
            }
        }) : /*#__PURE__*/ React.createElement(CircularProgress, {
            size: 60
        }));
    }
    return /*#__PURE__*/ React.createElement(Container, {
        maxWidth: "lg",
        className: "help-center-main-container"
    }, /*#__PURE__*/ React.createElement(Box, {
        className: "help-center-container"
    }, /*#__PURE__*/ React.createElement(Paper, {
        ref: setSectionRef('top-section'),
        elevation: 1,
        className: "help-center-header-section"
    }, renderHeaderWithImage()), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            my: 2
        }
    }, /*#__PURE__*/ React.createElement("input", {
        type: "text",
        placeholder: "Search content...",
        value: searchTerm,
        onChange: function onChange(e) {
            return setSearchTerm(e.target.value);
        },
        style: {
            width: '100%',
            padding: '12px 16px',
            fontSize: '16px',
            border: "2px solid ".concat(theme.palette.divider),
            borderRadius: '8px',
            fontFamily: 'inherit',
            boxSizing: 'border-box',
            outline: 'none',
            transition: 'border-color 0.2s'
        },
        onFocus: function onFocus(e) {
            e.currentTarget.style.borderColor = theme.palette.primary.main;
        },
        onBlur: function onBlur(e) {
            e.currentTarget.style.borderColor = theme.palette.divider;
        }
    })), hasValidSections && /*#__PURE__*/ React.createElement(Paper, {
        ref: setSectionRef('index-section'),
        elevation: 1,
        className: "help-center-index-section"
    }, renderIndexContent()), sections.map(function (section) {
        var _configState$settings5;
        return /*#__PURE__*/ React.createElement(Paper, {
            key: section.id,
            id: section.id,
            elevation: 1,
            ref: setSectionRef(section.id),
            className: "help-center-section",
            sx: {
                '& h1': _objectSpread(_objectSpread({}, theme.typography.h4), {}, {
                    color: theme.palette.text.primary
                }),
                '& h2': _objectSpread(_objectSpread({}, theme.typography.h5), {}, {
                    color: theme.palette.text.primary
                }),
                '& h3': _objectSpread(_objectSpread({}, theme.typography.h6), {}, {
                    color: theme.palette.text.primary
                }),
                '& p': _objectSpread({}, theme.typography.body1),
                '& a': {
                    color: (configState === null || configState === void 0 || (_configState$settings5 = configState.settings) === null || _configState$settings5 === void 0 ? void 0 : _configState$settings5.button_color) || theme.palette.primary.main
                },
                '& strong, & b': {
                    color: theme.palette.text.primary
                },
                '& iframe': {
                    width: '100%',
                    minHeight: '400px',
                    border: 0,
                    borderRadius: '8px',
                    display: 'block'
                },
                '& video': {
                    width: '100%',
                    display: 'block',
                    borderRadius: '8px'
                },
                '& mark': {
                    backgroundColor: '#ffeb3b',
                    padding: 0
                }
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            ref: setSectionContentRef(section.id),
            dangerouslySetInnerHTML: {
                __html: section.content
            }
        }));
    })));
};
export default authenticatedRoute(HelpCenterGuideViewer);
